import { UserLoginType, UserHome, HomeType } from '@app/entities/enums/user/user.enum';

export class UserLogin {
  login_type!: UserLoginType;
  phones!: string[];
  app_type!: UserHome;
  home_type!: HomeType;
}

export class UserLoginPhone {
  phone!: string;
}
